module.exports = __webpack_public_path__ + "img/pr-10.e1af9818.png";